/* eslint-disable consistent-return */
import { useSocket } from "contexts/socketcontext/hooks";
import { useEffect, useRef } from "react";

type Params = {
  eventKey: string,
  callback: (...args: any[]) => void,
  filter?: (...args: any[]) => boolean
}

export const useSubscribeToSocketEvent = ({
  eventKey,
  callback,
  filter
}: Params) => {
  const { socket } = useSocket();
  const callbackRef = useRef(callback);
  const filterRef = useRef(filter);

  callbackRef.current = callback;
  filterRef.current = filter;

  useEffect(() => {
    if (!socket) return;

    const handler = (...args: any[]) => {
      if (filterRef.current && !filterRef.current(...args)) return;
      callbackRef.current(...args);
    };

    socket.on(eventKey, handler);

    return () => {
      socket.removeListener(eventKey, handler);
    };
  }, [socket, eventKey]);
};
